import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ChargesService } from 'src/app/services/charges.service';
import { CategoryService } from 'src/app/services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EditChargesComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  submitted = false;
  pagetitle: string;
  public loggedInUser;
  public raceToGoldModule;
  public loggedInUserPermissions;
  public chargePermissions: any[] = [];
  chargesFormGroup: FormGroup;
  categoryList: any;
  feeTypes: { name: string; value: string; }[] = [];
  platformModulesList:any[] = [];
  id: string;
  
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private tokenStorageService: TokenStorageService,
    private messageService: MessageService,
    private chargesService: ChargesService,
    private categoryService: CategoryService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.loggedInUser = this.tokenStorageService.getUser();

    this.raceToGoldModule = "Race To Gold";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();

    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.raceToGoldModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.chargePermissions.push(permissionObj);
      }
    });

    this.feeTypes = [
      { name: 'Flat', value: 'flat' },
      { name: 'Percentage', value: 'percentage' },
    ]

    if (this.chargePermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.chargePermissions = this.chargePermissions[0]['permission'];

    this.pagetitle = 'Platform and Convenience Fee';

    this.chargesFormGroup = this.formBuilder.group({});
    this.getChargedModulesList();
  }
  
  getChargedModulesList() {
    const query = `?filterByParentCategory=Platform and Convenience Fee`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.platformModulesList = data.data.items;
      this.platformModulesList.forEach((module:any) => {
        this.chargesFormGroup.addControl(module.name.toLowerCase(),this.platformAndConvenienceFeeFormGroup); 
        this.f(module.name).platformFee.disable();
        this.f(module.name).platformFeeType.disable();
        this.f(module.name).convenienceFee.disable();
        this.f(module.name).convenienceFeeType.disable();
      })
      setTimeout(() => {
        this.getAllPlatformAndConvenienceFeeData(this.id);
      },1000);
    })
  }

  getAllPlatformAndConvenienceFeeData(id:string) {
    this.chargesService.getPlatformAndConvenienceFeesById(id).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      Object.entries(data?.fees).forEach(ele => {
        this.chargesFormGroup.controls[ele[0]]['controls'].platformFeeStatus.setValue(ele[1]['platformFeeStatus']);
        this.chargesFormGroup.controls[ele[0]]['controls'].convenienceFeeStatus.setValue(ele[1]['convenienceFeeStatus']);
        if (ele[1]['platformFeeStatus']) {
          this.f(ele[0]).platformFee.enable();
          this.f(ele[0]).platformFeeType.enable();
          this.chargesFormGroup.controls[ele[0]]['controls'].platformFee.setValue(ele[1]['platformFee']);
          this.chargesFormGroup.controls[ele[0]]['controls'].platformFeeType.setValue(this.feeTypes.find(fee => fee.value === ele[1]['platformFeeType']));
        } else {
          this.chargesFormGroup.controls[ele[0]]['controls'].platformFee.disable();
          this.chargesFormGroup.controls[ele[0]]['controls'].platformFeeType.disable();
        }
        if (ele[1]['convenienceFeeStatus']) {
          this.f(ele[0]).convenienceFee.enable();
          this.f(ele[0]).convenienceFeeType.enable();
          this.chargesFormGroup.controls[ele[0]]['controls'].convenienceFee.setValue(ele[1]['convenienceFee']);
          this.chargesFormGroup.controls[ele[0]]['controls'].convenienceFeeType.setValue(this.feeTypes.find(fee => fee.value === ele[1]['convenienceFeeType']));
        } else {
          this.chargesFormGroup.controls[ele[0]]['controls'].convenienceFee.disable();
          this.chargesFormGroup.controls[ele[0]]['controls'].convenienceFeeType.disable();
        }
      })
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    })
  }
  
  get platformAndConvenienceFeeFormGroup() {
    return this.formBuilder.group({
      platformFee: new FormControl(null),
      platformFeeType: new FormControl(null),
      platformFeeStatus: new FormControl(false),
      convenienceFee: new FormControl(null),
      convenienceFeeType: new FormControl(null),
      convenienceFeeStatus: new FormControl(false)
    });
  }
  
  percentageValidatorFunc(formControl: AbstractControl) {
    return (formControl.value < 1 || formControl.value > 100) ? { percentageValidator: true } : null;
  }

  onSelectPlatformFeeType(event,platformModule) {
    this.commonFunctionForFeeTypeSelection(event,platformModule,'platformFee');
  }
  
  onPlatFormFeeStatusChange(event,platformModule) {
    this.commonFunctionForFeeStatusChange(event,platformModule,'platformFee','platformFeeType');
  }
  
  onSelectConvenienceFeeType(event,platformModule) {
    this.commonFunctionForFeeTypeSelection(event,platformModule,'convenienceFee');
  }

  onConvenienceFeeStatusChange(event,platformModule) {
    this.commonFunctionForFeeStatusChange(event,platformModule,'convenienceFee','convenienceFeeType');
  }

  commonFunctionForFeeTypeSelection(event,platformModule,controlName) {
    if (event.value.value === 'flat') {
      this.f(platformModule)[controlName].setValidators([Validators.min(1)]);
    } else {
      this.f(platformModule)[controlName].setValidators([this.percentageValidatorFunc]);
    }
    this.f(platformModule)[controlName].updateValueAndValidity();
  }

  commonFunctionForFeeStatusChange(event,platformModule,controlName1,controlName2) {
    if (event.checked) {
      this.f(platformModule)[controlName1].setValidators([Validators.required]);
      this.f(platformModule)[controlName2].setValidators([Validators.required]);
      this.f(platformModule)[controlName1].enable();
      this.f(platformModule)[controlName2].enable();
    } else {  
      this.f(platformModule)[controlName1].reset();
      this.f(platformModule)[controlName2].reset();
      this.f(platformModule)[controlName1].setValidators(null);
      this.f(platformModule)[controlName2].setValidators(null);
      this.f(platformModule)[controlName1].disable();
      this.f(platformModule)[controlName2].disable();
    }
    this.f(platformModule)[controlName1].updateValueAndValidity();
    this.f(platformModule)[controlName2].updateValueAndValidity();
  }

  f(controlName:string) {
    return this.chargesFormGroup.controls[controlName.toLowerCase()]['controls'];
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.chargesFormGroup.invalid) {
      return;
    }
    Object.values(this.chargesFormGroup.value).forEach((ele:any) => {
      if (ele.platformFeeStatus) {
        ele['platformFeeType'] = ele['platformFeeType'].value
      }
      if (ele.convenienceFeeStatus) {
        ele['convenienceFeeType'] = ele['convenienceFeeType'].value
      }
    })
    let chargesFormData = {};
    chargesFormData['fees'] = JSON.parse(JSON.stringify(this.chargesFormGroup.value))

    chargesFormData = JSON.stringify(chargesFormData, null, 4);

    this.chargesService.updatePlatformAndConvenienceFee(this.id,chargesFormData).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Platform and Convenience Fee Updated Successfully!!', life: 6000 });
      setTimeout(()=>{
        this.getAllPlatformAndConvenienceFeeData(this.id);
      },2000);
    },(err) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
